"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBackToMyFirm = exports.useSwitchIntoCompany = exports.useCreateCompany = void 0;
var interfaces_1 = require("@hudled/interfaces");
var firestore_1 = require("firebase/firestore");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
// import { useHistory } from 'react-router-dom';
var companies_1 = require("utils/companies");
var firestore_2 = require("utils/firebase/firestore");
var logging_1 = require("utils/logging");
var single_1 = require("utils/selectors/single");
// import { delay } from '@hudled/end2end';
var useCreateCompany = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _a = __read((0, exports.useSwitchIntoCompany)(), 1), switchIntoCompany = _a[0];
    return function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var companiesRef, e_1, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    companiesRef = (0, firestore_2.makeDocRef)('companies');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, firestore_1.setDoc)(companiesRef, (0, companies_1.makeNewCompany)('ACC_FIRM_CUSTOMER')(__assign(__assign({}, values), { accountingFirmId: profile.mainCompanyId, accountantCreatorId: profile.id, createdByAccountant: true })))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    (0, logging_1.logError)('Issue creating company');
                    throw e_1;
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, switchIntoCompany(companiesRef.id, interfaces_1.ACCESS_LEVEL.Accountant, true)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _a.sent();
                    (0, logging_1.logError)('Issue switching Into Company');
                    throw e_2;
                case 7: return [2 /*return*/];
            }
        });
    }); };
};
exports.useCreateCompany = useCreateCompany;
var useSwitchIntoCompany = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _a = __read((0, react_1.useState)(false), 2), isSwitching = _a[0], setIsSwitching = _a[1];
    return [
        function (companyId, accessLevel, isCreate) { return __awaiter(void 0, void 0, void 0, function () {
            var usrChanges;
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setIsSwitching(true);
                        usrChanges = {
                            companyId: companyId,
                            accessLevel: (_b = accessLevel !== null && accessLevel !== void 0 ? accessLevel : profile.companyAccessLevel[companyId]) !== null && _b !== void 0 ? _b : (profile.isAccountant ? 'ACCOUNTANT' : undefined),
                        };
                        if (isCreate) {
                            Object.assign(usrChanges, {
                                companyIds: (0, firestore_1.arrayUnion)(companyId),
                                companyAccessLevel: (_a = {}, _a[companyId] = interfaces_1.ACCESS_LEVEL.Accountant, _a),
                            });
                        }
                        return [4 /*yield*/, (0, firestore_2.setMergeDoc)('users', profile.id, usrChanges)];
                    case 1:
                        _c.sent();
                        window.location.href = '/';
                        return [2 /*return*/];
                }
            });
        }); },
        isSwitching,
    ];
};
exports.useSwitchIntoCompany = useSwitchIntoCompany;
var useBackToMyFirm = function () {
    var _a = __read((0, exports.useSwitchIntoCompany)(), 2), switchIntoCompany = _a[0], isSwitching = _a[1];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var mainCompanyId = profile.mainCompanyId, companyId = profile.companyId;
    return [
        mainCompanyId && mainCompanyId !== companyId ? function () { return switchIntoCompany(mainCompanyId); } : null,
        isSwitching,
    ];
};
exports.useBackToMyFirm = useBackToMyFirm;
